import { AlertTriangle } from "lucide-react";
import type { Card } from "../../types/chat";

interface Props {
  card: Card;
}

export function ErrorCard({ card }: Props) {
  const message = (card.data.message as string) ?? "An error occurred";
  const retryable = card.data.retryable as boolean ?? false;

  return (
    <div className="rounded-lg border border-destructive/30 bg-destructive/10 p-3" role="alert">
      <div className="flex items-start gap-2">
        <AlertTriangle className="size-4 text-destructive shrink-0 mt-0.5" />
        <div>
          <p className="text-sm text-destructive">{message}</p>
          {retryable && <p className="text-xs text-muted-foreground mt-1">You can try again.</p>}
        </div>
      </div>
    </div>
  );
}
